import { Expression } from './Expression.js';
import { OclExecutionContext } from '../OclExecutionContext.js';

export class ConstExpression extends Expression {
  constructor(public value: any) {
    super();
  }
  evaluate(visitor: OclExecutionContext, localVariables?: any): any {
    return this.value;
  }
}
